var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGiEdit(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_984_8513",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "url(#paint0_linear_984_8513)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_984_8513)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.85332 16.8189C2.8512 16.8097 2.84738 16.8002 2.847 16.7906C2.84606 16.7656 2.84658 16.7406 2.84658 16.7156C2.84658 12.9654 2.84658 9.2151 2.84696 5.46486C2.84696 5.433 2.83055 5.39399 2.85676 5.37098C2.88391 5.34715 2.93383 5.36139 2.97357 5.36139C5.81796 5.36094 8.66234 5.36097 11.5068 5.36097C11.5508 5.36097 11.5948 5.3618 11.6388 5.36064C11.85 5.3549 12.0221 5.22539 12.0421 5.05195C12.0596 4.90032 11.9367 4.74202 11.7235 4.69997C11.6837 4.69214 11.6437 4.68629 11.6023 4.68771C11.5772 4.68858 11.552 4.68786 11.5269 4.68786C8.51592 4.68786 5.50495 4.68786 2.49397 4.68801C2.44386 4.68801 2.39399 4.68704 2.34392 4.69573C2.14471 4.73021 2.0089 4.85639 1.99999 5.01829C1.99905 5.03576 1.99971 5.05326 1.99971 5.07076C1.99971 9.08585 1.99971 13.101 1.99971 17.1161C1.99971 17.1535 2.00121 17.1905 2.0106 17.2277C2.05029 17.3857 2.22579 17.4844 2.37457 17.492C2.41841 17.4942 2.46239 17.4961 2.50627 17.4961C3.34541 17.4963 4.1846 17.4963 5.02374 17.4963C8.33957 17.4963 11.6554 17.4963 14.9712 17.4961C15.0214 17.4961 15.0719 17.4951 15.1217 17.4906C15.3251 17.4721 15.4797 17.325 15.4819 17.1742C15.4823 17.1492 15.4824 17.1242 15.4824 17.0992C15.4824 14.5333 15.4824 11.9673 15.4824 9.40132C15.4824 9.37632 15.4817 9.35137 15.482 9.32637C15.4837 9.1952 15.3518 9.02289 15.0962 9.00449C14.8718 8.98833 14.6838 9.11654 14.6474 9.27023C14.6405 9.2998 14.6347 9.32922 14.6353 9.35939C14.6359 9.38937 14.6354 9.41935 14.6354 9.44933C14.6354 11.8729 14.6354 14.2964 14.635 16.72C14.635 16.752 14.6519 16.7922 14.6252 16.8141C14.5952 16.8389 14.5423 16.8237 14.4996 16.8237C10.6589 16.8242 6.81822 16.8242 2.97749 16.824C2.9369 16.824 2.89584 16.8282 2.85318 16.8191L2.85332 16.8189Z",
    fill: "url(#paint1_linear_984_8513)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.99436 9.47331C9.00027 9.49238 9.01948 9.50438 9.0345 9.51941C9.76199 10.2473 10.4897 10.9749 11.2174 11.7026C11.2793 11.7645 11.2705 11.7626 11.3309 11.7029C11.3463 11.6876 11.3616 11.6722 11.377 11.6569C12.9639 10.0701 14.5509 8.48332 16.1375 6.89621C16.232 6.80175 16.2325 6.82877 16.1408 6.737C15.4266 6.02217 14.7119 5.3078 13.9971 4.59348C13.9754 4.57176 13.957 4.5459 13.9328 4.53516C12.2876 6.18026 10.6439 7.82388 8.99436 9.47331Z",
    fill: "url(#paint2_linear_984_8513)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6046 6.42619C16.6299 6.40242 16.6459 6.38814 16.6611 6.37302C16.8629 6.1714 17.0647 5.96972 17.2662 5.76786C17.4887 5.54512 17.6357 5.28033 17.7033 4.97284C17.8907 4.11992 17.3852 3.27881 16.5384 3.05439C15.9625 2.90183 15.3695 3.07848 14.9714 3.48044C14.7728 3.6809 14.5724 3.8796 14.373 4.07918C14.3578 4.09434 14.3432 4.11015 14.3254 4.12876C14.3393 4.16234 14.3684 4.18173 14.3916 4.2049C14.9481 4.76215 15.5051 5.31898 16.0621 5.87586C16.22 6.03372 16.378 6.19144 16.5355 6.34963C16.5574 6.37153 16.5771 6.39553 16.6046 6.42619Z",
    fill: "url(#paint3_linear_984_8513)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.67614 9.94536C8.65028 9.96913 8.64847 9.99541 8.64079 10.018C8.34787 10.882 8.05601 11.7463 7.76331 12.6104C7.74187 12.6737 7.73243 12.7366 7.75164 12.8015C7.79685 12.9541 7.95038 13.0379 8.10303 12.9891C8.27977 12.9326 8.45512 12.8716 8.63093 12.8122C9.32237 12.5787 10.0138 12.3451 10.705 12.1109C10.7365 12.1002 10.7712 12.0953 10.8008 12.0704C10.7924 12.0586 10.7866 12.0481 10.7786 12.0396C10.6311 11.8819 8.73535 9.99359 8.6761 9.94531L8.67614 9.94536Z",
    fill: "url(#paint4_linear_984_8513)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_984_8513",
    x1: 10,
    y1: 0,
    x2: 10,
    y2: 20,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE8888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0D98C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_984_8513",
    x1: 8.74095,
    y1: 4.6875,
    x2: 8.74095,
    y2: 17.4963,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE8888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0D98C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_984_8513",
    x1: 12.6017,
    y1: 4.53516,
    x2: 12.6017,
    y2: 11.7484,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE8888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0D98C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_984_8513",
    x1: 16.0338,
    y1: 3,
    x2: 16.0338,
    y2: 6.42619,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE8888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0D98C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_984_8513",
    x1: 9.27101,
    y1: 9.94531,
    x2: 9.27101,
    y2: 13.003,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE8888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0D98C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGiEdit);
export default __webpack_public_path__ + "static/media/gi_edit.08c0fd523c391816b532be434cc82361.svg";
export { ForwardRef as ReactComponent };